<div class="flex align-items-center justify-content-center h-screen">
    <div class="login-box p-component py-4 shadow-2 border-round component-backdrop standalone-page-width">
        <div class="text-center mb-2">
            <img id="logo" src="assets/logoFull.png" alt="Logo">
            <h2>Welcome</h2>
            <pwa-auth #authCmp></pwa-auth>
        </div>
    </div>
</div>